import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { isObservable, type Observable } from 'rxjs';

import { type BreadcrumbItem, BreadcrumbService } from '../../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterLink, MatIconModule, TranslocoPipe],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  readonly breadcrumbs$: Observable<BreadcrumbItem[]> = inject(BreadcrumbService).breadcrumbs$;

  isObservable(val: unknown): val is Observable<unknown> {
    return isObservable(val);
  }

  trackBreadcrumb(index: number, breadcrumb: BreadcrumbItem): string {
    return `${breadcrumb.url ?? 'no-url'}|${index}`;
  }
}
